import React from 'react';

import {
  ChakraToolTip,
  EquipUIFireflyV2Theme,
  FAIconName,
  FireflyButton,
} from '@equip.health/ui';

import { NoteEvents } from '~/analytics';
import { AnalyticsSourceValues } from '~/lib/constants/AnalyticsSource.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';

const { neutral } = EquipUIFireflyV2Theme.colors;

const TOP_LEVEL_ID = 'schedule-note';

interface ScheduleNoteProps {
  isAddNote: boolean;
  isNoteInDraftState: boolean;
  isDisabled: boolean;
  isShowTooltip?: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const ScheduleNote = ({
  isAddNote,
  isNoteInDraftState,
  isDisabled,
  isShowTooltip = false,
  onClick,
}: ScheduleNoteProps) => {
  const { trackEvent } = useAnalytics();

  const handleTrackEvent = () => {
    let eventType: NoteEvents;
    if (isAddNote) {
      eventType = NoteEvents.addNoteAppointmentsTabButtonClicked;
    } else if (isNoteInDraftState) {
      eventType = NoteEvents.editNoteAppointmentsTabButtonClicked;
    } else {
      eventType = NoteEvents.viewNoteAppointmentsTabButtonClicked;
    }
    trackEvent(eventType, {
      Source: AnalyticsSourceValues.PATIENT_CALENDAR_TAB,
    });
  };

  const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    handleTrackEvent();
    onClick(event);
  };

  return (
    <ChakraToolTip
      bg="white"
      border={`1px solid ${neutral.background.secondary}`}
      borderRadius="8px"
      color="neutral.primary"
      hasArrow
      hidden={!isShowTooltip}
      id={`${TOP_LEVEL_ID}__is-participant-tooltip`}
      padding="0px"
      placement="left-start"
      shouldWrapChildren
    >
      <>
        {!isAddNote &&
          (isNoteInDraftState ? (
            <FireflyButton
              id={`${TOP_LEVEL_ID}__edit-draft`}
              isDisabled={isDisabled}
              leftIcon={FAIconName.penRegular}
              onClick={handleOnClick}
              size="small"
              variant="secondary"
            >
              Edit draft
            </FireflyButton>
          ) : (
            <FireflyButton
              id={`${TOP_LEVEL_ID}__view-note`}
              isDisabled={isDisabled}
              leftIcon={FAIconName.fileRegular}
              onClick={handleOnClick}
              size="small"
              variant="secondary"
            >
              View note
            </FireflyButton>
          ))}
        {isAddNote && (
          <FireflyButton
            id={`${TOP_LEVEL_ID}__add-note-new`}
            isDisabled={isDisabled}
            leftIcon={FAIconName.plusSolid}
            onClick={handleOnClick}
            size="small"
            variant="secondary"
          >
            Add note
          </FireflyButton>
        )}
      </>
    </ChakraToolTip>
  );
};

export default ScheduleNote;
